
import { createSlice } from '@reduxjs/toolkit';
import { fetcherGet, fetcherPost } from '../utils/fetcher';
import { setLoader } from './commonSlice';
import { setOpenPopup } from './documentSlice';
import { APIS, isEmpty } from '../utils/constants';

const initialState = {
    getSupport: [],
    getAdminSupport:{data:[],pagination:{}}
}

const helpSupportSlice = createSlice({
    name: 'help-support',
    initialState,
    reducers: {
        setSupport: (state, action) => {
            state.getSupport = action.payload;
        },    
        setAdminSupport:(state,action) =>{
            state.getAdminSupport = {data:action.payload.result,pagination:action.payload.pagination}
        }     
    }
});

export function getAllHelpSupport() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS?.HELP_SUPPORT_DATA)
            .then((response) => {
                const helpSupport = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setSupport(helpSupport));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}
export function getAdminHelpSupport(page = 1, limit = 10, search = "") {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS?.HELP_SUPPORT_ADMIN_DATA}?search=${search}&page=${page}&limit=${limit}`)
            .then((response) => {
                const helpSupport = !isEmpty(response?.data) ? response?.data : [];
                dispatch(setAdminSupport(helpSupport));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}
export function postComment(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.POST_COMMENTS, payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(setOpenPopup(true))
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}



export const { setSupport,setAdminSupport } = helpSupportSlice.actions;
export default helpSupportSlice.reducer;